export const yupToKV = (yupError) => {
  let error = {};

  if (!yupError || !yupError.inner) return error;

  yupError.inner.forEach((err) => {
    const path = err.path;
    error[path] = err.message;
  });

  return error;
};
